"use client";
import b from "./index.es65.js";
import "./index.es16.js";
import e from "react";
import "./index.es17.js";
import "./index.es18.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import f from "./index.es66.js";
import i from "./index.es67.js";
const d = b.div`
  .bl-info-box {
    overflow: visible;
  }
`, w = ({
  type: c = "normal",
  content: l,
  title: t,
  sourceText: r,
  sourceUrl: a,
  className: m,
  tooltips: n,
  keyContext: s,
  htmlId: o
}) => {
  if (c === "infobox") {
    const p = o ? /* @__PURE__ */ e.createElement("h3", { id: o }, t) : t;
    return /* @__PURE__ */ e.createElement(d, { className: "bl-p-b-3" }, /* @__PURE__ */ e.createElement(f, { header: p }, /* @__PURE__ */ e.createElement(
      i,
      {
        content: l,
        keyContext: s,
        tooltips: n,
        className: m
      }
    ), r && a && /* @__PURE__ */ e.createElement("span", null, "Kilde:", " ", /* @__PURE__ */ e.createElement("a", { className: "bl-link", href: a }, r))));
  } else
    return /* @__PURE__ */ e.createElement("div", { className: "bl-p-b-3" }, !!t && /* @__PURE__ */ e.createElement("h3", { className: "bl-size-3", ...o ? { id: o } : {} }, t), /* @__PURE__ */ e.createElement(
      i,
      {
        content: l,
        keyContext: s,
        tooltips: n,
        className: m
      }
    ));
};
export {
  w as default
};
//# sourceMappingURL=index.es24.js.map
